var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833333333,13.3333333 C0.833333333,14.25 1.58333333,15 2.5,15 L9.16666667,15 C10.0833333,15 10.8333333,14.25 10.8333333,13.3333333 L10.8333333,3.33333333 L0.833333333,3.33333333 L0.833333333,13.3333333 Z M11.6666667,0.833333333 L8.75,0.833333333 L7.91666667,0 L3.75,0 L2.91666667,0.833333333 L0,0.833333333 L0,2.5 L11.6666667,2.5 L11.6666667,0.833333333 Z",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.0629ad4c.svg";
export { ForwardRef as ReactComponent };